import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./ComponentToPrint";

export default function PrintComponent() {
    let componentRef = useRef();

    return (
        <React.Fragment>

            {/* button to trigger printing of target component */}
            <ReactToPrint
                trigger={() => <button >Print</button>}
                content={() => componentRef}
            />
    
            {/* component to be printed */}
            <div style={{ display: "none" }}>
                <ComponentToPrint ref={(el) => (componentRef = el)} />
            </div>
        </React.Fragment>
    );
  }
